/**
 * Copyright 2020-present, TIENDUC.
 * All rights reserved.
 * @author ductt24@ghtk.com on 11/08/2020.
 * @module CAMERA SELECTORS
 */

import {
  dvrAdapter,
  scenarioAdapter,
  channelAdapter,
  setupAdapter,
  moduleAdapter,
  cartAdapter,
  dvrChannelAdapter,
  videoAdapter,
  serverAdapter,
} from "./reducer";
import _ from "lodash";

export const dvrSelectors = dvrAdapter.getSelectors(
  (state) => (state ? state.dvrs : dvrAdapter.getInitialState())
);

export const dvrChannelSelectors = dvrAdapter.getSelectors(
  (state) => (state ? state.dvrChannel : dvrChannelAdapter.getInitialState())
);
export const dvrSelectorsByPath = (state, path) =>
  _.get(state, ["dvrs", ...path]);

export const scenarioSelectors = scenarioAdapter.getSelectors(
  (state) => (state ? state.scenarios : scenarioAdapter.getInitialState())
);
export const setupSelectors = scenarioAdapter.getSelectors(
  (state) => (state ? state.setups : setupAdapter.getInitialState())
);
export const channelSelectors = channelAdapter.getSelectors(
  (state) => (state ? state.channels : channelAdapter.getInitialState())
);
export const moduleSelectors = channelAdapter.getSelectors(
  (state) => (state ? state.modules : moduleAdapter.getInitialState())
);
export const cartSelectors = channelAdapter.getSelectors(
  (state) => (state ? state.carts : cartAdapter.getInitialState())
);
export const videoSelectors = videoAdapter.getSelectors(
  (state) => (state ? state.video : videoAdapter.getInitialState())
);


export const cameraConfigSelectorsByPath = (state, path) =>
  _.get(state, ["cameraConfig", ...path]);
